<template>
  <div class="dialog-wrapper">
    <el-dialog
      title="添加正式授权"
      :visible.sync="currentValue"
      :before-close="cancleDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px">
      <div class="password-form">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item prop="password" label="密码：" :class="inputError ? 'is-error' : ''">
            <el-input v-model="form.password"></el-input>
            <div class="password-error-tip" v-if="inputError">再输错{{timeCount}}次今日将会被锁定</div>
            <div class="password-tip">在优图商务审核平台（内部）通过审核后，可获得正式授权密码</div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancleDialog()">取消</el-button>
        <el-button type="primary" @click="submitPassWord()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 确认添加结果 -->
    <el-dialog
      class="list-dialog"
      title="确认添加"
      :visible.sync="visibleList"
      :before-close="closeList"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1100px">
      <div class="add-table-list">
        <div class="add-table-tooltip">将以下SDK/私有化服务的正式授权单添加到当前账号?授权单只能被添加到一个账号，确认添加后密码失效。</div>
        <div class="add-table-tooltip">添加成功后正式授权单将添加到离线SDK/私有云授权列表中。</div>
        <el-table 
          :data="tableData">
          <el-table-column
            label="编号"
            width="90">
            <template slot-scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="名称"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.productname ? scope.row.productname : '无'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="绑定方式"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.type === KeyEnum.SdkGroupType[0].value || scope.row.type === KeyEnum.SdkGroupType[1].value">绑定APP</span>
              <span v-else>绑定设备</span>
            </template>
          </el-table-column>
          <el-table-column
            label="授权数量"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.device.num ? scope.row.device.num : '无'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="授权截止时间"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.end_date !== ''">{{DateUtils.format(new Date(scope.row.end_date), DateUtils.DateFormat.DEFAULT)}}</span>
              <span v-else>无</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeList()">再想想</el-button>
        <el-button type="primary" @click="submitImport()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/common/api';
import DateUtils from '@/common/DateUtils';
import ErrorHandler from '../js/ErrorHandler';
import { KeyEnum } from '@/common/OptionConstant';
export default {
  name: 'PasswordAdd',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      DateUtils,
      KeyEnum,
      currentValue: this.value,
      visibleResult: false,
      visibleList: false,
      inputError: false,
      timeCount: 0,
      times: 9,
      form: {
        password: ''
      },
      rules: {
        password: [{
          required: true,
          validator: this.validatePassword
        }]
      },
      tableData: []
    };
  },
  methods: {
    // 校验密码
    validatePassword(rule, value, callback) {
      if (value.trim() === '') {
        this.inputError = false;
        callback(new Error('请输入正式授权密码'));
      }
      callback();
    },

    // 关闭密码弹框
    cancleDialog() {
      this.$refs.form.resetFields();
      this.form.password = '';
      this.currentValue = false;
      this.inputError = false;
    },

    // 确认密码
    submitPassWord() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return;
        }
        let data = {
          password: this.form.password,
          confirmAdd: 0x1
        };
        const loading = this.loading();
        this.$loader.post(api.ytbusiness.QUERY_SERVICE, data, this.ajaxErrorCallback).then(result => {
          this.inputError = false;
          if (result.errorcode === 0 && result.errormsg === 'already used') {
            loading.close();
            this.$alert('该授权已被绑定,不可再次绑定', '获取密码', null);
            return;
          }
          if (result.errorcode === 0 && result.errormsg === 'invalid password') { // invalid password
            loading.close();
            if (result.times >= 0) {
              this.timeCount = this.times - result.times;
              this.inputError = true;
            }
            return;
          }
          result.result.items.forEach(item => {
            let productList = [];
            if (item.type === KeyEnum.SdkGroupType[0].value || item.type === KeyEnum.SdkGroupType[1].value) {
              item.app.products.forEach(row => {
                productList.push(row.name);
              });
              item.productname = productList.join('、');
            } else {
              item.device.products.forEach(row => {
                productList.push(row.name);
              });
              item.productname = productList.join('、');
            }
          });
          this.tableData = result.result.items;
          this.currentValue = false;
          loading.close();
          this.visibleList = true;
        }).catch(() => {
          loading.close();
        });
      });
    },

    // 关闭授权单
    closeList() {
      this.visibleList = false;
      this.cancleDialog();
    },

    // 添加成功
    submitImport() {
      let data = {
        password: this.form.password,
        confirmAdd: 0x2
      };
      const loading = this.loading();
      this.$loader.post(api.ytbusiness.QUERY_SERVICE, data, this.ajaxErrorCallback).then((result) => {
        loading.close();
        this.$alert('添加成功', '添加结果', null).then(() => {
          this.closeList();
          this.$emit('query');
        });
      }).catch(() => {
        loading.close();
        this.$alert('您输入的密码已失效', '添加结果', null);
        this.closeList();
      });
    }
  },
  created() {
    this.ajaxErrorCallback = ErrorHandler.ajaxErrorCallback(this);
  },
  watch: {
    value(val) {
      this.currentValue = val;
    },
    currentValue(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="less">
.el-message-box__wrapper {
  background: rgba(0, 0, 0, .5);
}
.el-dialog__wrapper {
  background: rgba(0, 0, 0, .5);
}
.v-modal {
  display: none;
}
.dialog-wrapper {
  .el-dialog__body {
    .result-dialog {
      text-align: center;
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      &.result-footer {
        text-align: center;
      }
    }
  }
  .password-form {
    .el-form {
      .el-form-item {
        .el-form-item__label {
          width: 134px;
          margin-right: 38px;
          text-align: right;
        }
        .el-form-item__content {
          width: 448px;
          height: 40px;
          .el-form-item__error {
            padding: 24px 25px;
          }
          .password-tip {
            line-height: 20px;
          }
          .password-error-tip {
            color: #e94e56;
            line-height: 20px;
          }
        }
      }
    }
  }
}
.list-dialog {
  .el-dalog {}
  .el-dialog__body {
    .add-table-list {
      padding: 0 50px;
      .add-table-tooltip {
        text-align: center;
        font-size: 16px;
        margin-bottom: 20px;
      }
      .el-table {
        width: 100%;
        border: 1px solid #ebeef5;
        .el-table__body-wrapper {
          overflow-y: auto;
          height: auto;
          max-height: 500px;
        }
      }
    }
  }
  .el-dialog__footer {
    .dialog-footer {
      text-align: center;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/open/panels/application/panels/common/PasswordAdd.vue